import { DotLegalOverflowMenuItem } from "@dotlegal/dotlegal-ui-components";
import { getAiOverflowMenuItem } from "../../aiOverflowMenuItem.ts";

/** The overflow entry that turns a stored contract document into a contract of its own. */
export function getCreateContractWithAiOverflowMenuItem(
    onClick: () => void,
    blockedTooltip: string | undefined,
    translateString: (key: string) => string,
    disabledTooltip?: string
): DotLegalOverflowMenuItem {
    return getAiOverflowMenuItem(onClick, "createContractWithAi", "createContractWithAiDescription", blockedTooltip, translateString, disabledTooltip);
}
